import { Signal, useComputed } from "@suse-o11y/signal";

/**
 * This signal holds whether dropdown menu is enabled in the application.
 * It is initially false to avoid loading the heavy `@radix-ui/react-dropdown-menu` library
 * until the user hovers of focuses a dropdown menu trigger.
 */
const isEnabled = Signal(false);

export function useIsEnabled(): boolean {
	return useComputed((monitor) => isEnabled.read(monitor), []);
}

export function enable(): void {
	isEnabled.write(true);
}
